"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const moment_1 = __importDefault(require("moment"));
const ModalPopupComponent_1 = __importDefault(require("@mwater/react-library/lib/ModalPopupComponent"));
const querystring_1 = __importDefault(require("querystring"));
const expressions_1 = require("@mwater/expressions");
const ui = __importStar(require("./UIComponents"));
const expressions_ui_1 = require("@mwater/expressions-ui");
// Link that when clicked popup up a modal window allowing user to select a form
// with an Site question to the extraTables
class MWaterAddRelatedFormComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            waitingForTable: null // Set to table id that is being waited for as the result of being selected
        };
    }
    componentWillReceiveProps(nextProps) {
        // If waiting and table has arrived, cancel waiting
        if (this.state.waitingForTable && nextProps.schema.getTable(this.state.waitingForTable)) {
            return this.setState({ waitingForTable: null });
        }
    }
    handleOpen = () => {
        return this.setState({ open: true });
    };
    handleSelect = (table) => {
        this.setState({ open: false });
        // Wait for table if not in schema
        if (!this.props.schema.getTable(table)) {
            this.setState({ waitingForTable: table });
        }
        return this.props.onSelect(table);
    };
    render() {
        return R("div", null, this.state.waitingForTable
            ? R("div", null, R("i", { className: "fa fa-spin fa-spinner" }), ` ${T `Adding...`}`)
            : R("a", { className: "btn btn-link", onClick: this.handleOpen }, T `+ Add Related Survey`), this.state.open
            ? R(AddRelatedFormModalComponent, {
                table: this.props.table,
                apiUrl: this.props.apiUrl,
                client: this.props.client,
                user: this.props.user,
                onSelect: this.handleSelect,
                onCancel: () => this.setState({ open: false })
            })
            : undefined);
    }
}
exports.default = MWaterAddRelatedFormComponent;
/** Actual modal that displays the list of forms */
class AddRelatedFormModalComponent extends react_1.default.Component {
    static contextType = expressions_ui_1.LocaleContext;
    constructor(props) {
        super(props);
        this.state = {
            items: null,
            search: ""
        };
    }
    componentDidMount() {
        // Get all forms visible to user that have _entity_types that include table
        const query = {};
        query.selector = JSON.stringify({
            state: { $ne: "deleted" },
            _entity_types: { $in: [this.props.table.split(".")[1]] }
        });
        query.fields = JSON.stringify({ "_id": 1, "design.name": 1, "modified": 1, "created": 1 });
        if (this.props.client) {
            query.client = this.props.client;
        }
        // Get list of related forms
        return jquery_1.default.getJSON(this.props.apiUrl + "forms?" + querystring_1.default.stringify(query), (forms) => {
            // Sort by modified.on desc but first by user
            forms = lodash_1.default.sortByOrder(forms, [(form) => (form.created.by === this.props.user ? 1 : 0), (form) => form.modified.on], ["desc", "desc"]);
            // Get _id, name, and description
            const items = lodash_1.default.map(forms, (form) => ({
                name: expressions_1.ExprUtils.localizeString(form.design.name, this.context),
                desc: `${T `Modified`} ${(0, moment_1.default)(form.modified.on, moment_1.default.ISO_8601).format("ll")}`,
                onClick: this.props.onSelect.bind(null, "responses:" + form._id)
            }));
            this.setState({ items });
        }).fail((xhr) => {
            this.setState({ error: xhr.responseText });
        });
    }
    renderContents() {
        if (!this.state.items) {
            return R("div", { className: "alert alert-info" }, R("i", { className: "fa fa-spin fa-spinner" }), ` ${T `Loading...`}`);
        }
        let { items } = this.state;
        // Filter by search
        if (this.state.search) {
            const searchStringRegExp = new RegExp(escapeRegex(this.state.search), "i");
            items = lodash_1.default.filter(items, (item) => item.name.match(searchStringRegExp));
        }
        return R("div", null, R("input", {
            type: "text",
            className: "form-control",
            placeholder: T `Search...`,
            key: "search",
            style: { marginBottom: 10 },
            value: this.state.search,
            onChange: (ev) => this.setState({ search: ev.target.value })
        }), R(ui.OptionListComponent, { items }));
    }
    render() {
        return R(ModalPopupComponent_1.default, {
            showCloseX: true,
            onClose: this.props.onCancel,
            header: T `Add Related Survey`
        }, this.renderContents());
    }
}
function escapeRegex(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
